var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Campo = /** @class */ (function () {
    function Campo(input, etiqueta, visibilidad, obligatorio) {
        this.input = input;
        this.etiqueta = etiqueta;
        this.visibilidad = visibilidad;
        this.obligatorio = obligatorio;
    }
    return Campo;
}());
var buscaCampoDeEtiqueta = function (etiqueta) {
    var atributoFor = etiqueta.getAttribute('for');
    if (atributoFor) {
        return document.getElementById(atributoFor);
    }
    return null;
}, buscaCampos = function (formulario) {
    var campos = {}, etiquetas = formulario.querySelectorAll(".campo label");
    [].forEach.call(etiquetas, function (etiqueta) {
        var input = buscaCampoDeEtiqueta(etiqueta);
        if (input) {
            var padre = input.parentNode;
            if (padre) {
                var campo = new Campo(input, etiqueta.cloneNode(true), JSON.parse(padre.getAttribute('data-visibilidad') || '{}'), input.required);
                campos[input.id] = campo;
            }
        }
    });
    return campos;
}, configuraEtiquetas = function (formulario) {
    var campos = {}, etiquetas = formulario.querySelectorAll(".campo:not(.campo--checkbox) > label");
    [].forEach.call(etiquetas, function (etiqueta) {
        var _a;
        var input = buscaCampoDeEtiqueta(etiqueta);
        if (input && !input.getAttribute('placeholder')) {
            var padre = input.parentNode;
            if (padre) {
                var campo = new Campo(input, etiqueta, JSON.parse(padre.getAttribute('data-visibilidad') || '{}'), input.required);
                campos[input.id] = campo;
                if (((_a = campo.input.value) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                    etiqueta.classList.add('is-inactiva');
                }
            }
        }
    });
    formulario.addEventListener('blur', function (e) {
        var _a;
        var input = e.target, campo = campos[input.id];
        if (campo && !((_a = campo.input.value) === null || _a === void 0 ? void 0 : _a.trim()) && !campo.input.classList.contains('con-archivo')) {
            campo.etiqueta.classList.add('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'transparent';
            }
        }
    }, true);
    formulario.addEventListener('focus', function (e) {
        var input = e.target, campo = campos[input.id];
        if (campo) {
            campo.etiqueta.classList.remove('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'currentColor';
            }
        }
    }, true);
    return campos;
}, reinicia = function (campos) {
    Object.keys(campos).forEach(function (key) {
        var _a = campos[key], input = _a.input, etiqueta = _a.etiqueta;
        if (!input.value || input.value.trim() === '') {
            etiqueta.classList.add('is-inactiva');
            if (input.getAttribute('type') === 'date') {
                input.style.color = 'transparent';
            }
        }
    });
}, configuraSubmit = function (formulario, opciones) {
    var submit = formulario.querySelector('[type="submit"]');
    var enviado = opciones.enviado || (function () {
    });
    var offset = opciones.offset || (function () { return 0; });
    var dataLayer = opciones.dataLayer;
    formulario.addEventListener('submit', function (e) {
        e.preventDefault();
        submit.disabled = true;
        var promesa = Promise.resolve();
        if (window.recaptcha) {
            promesa = new Promise(function (resolve) {
                window.grecaptcha.enterprise.ready(function () { return __awaiter(void 0, void 0, void 0, function () {
                    var token, input;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, window.grecaptcha.enterprise.execute(window.recaptcha, { action: 'submit' })];
                            case 1:
                                token = _a.sent();
                                input = formulario.querySelector('input[name="g-recaptcha-response"]') || document.createElement('input');
                                input.setAttribute('type', 'hidden');
                                input.setAttribute('name', 'g-recaptcha-response');
                                input.setAttribute('value', token);
                                formulario.appendChild(input);
                                resolve();
                                return [2 /*return*/];
                        }
                    });
                }); });
            });
        }
        promesa.then(function () {
            fetch(formulario.getAttribute('action') || location.href, {
                method: 'post',
                body: new FormData(formulario)
            })
                .then(function (x) {
                if (x.redirected) {
                    enviado(formulario);
                    dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
                        event: 'formulario-enviado',
                        formulario: formulario.id
                    });
                    location.href = x.url;
                }
                return x.text();
            })
                .then(function (text) { return (new DOMParser()).parseFromString(text, 'text/html'); })
                .then(function (dom) {
                var f = dom.querySelector("#".concat(formulario.getAttribute('id')));
                if (f) {
                    formulario.parentElement.replaceChild(f, formulario);
                    inicializaFormulario(f, opciones);
                }
                window.scrollTo(0, formulario.getBoundingClientRect().top + scrollY - offset());
                formulario.classList.add('enviado');
                enviado(formulario);
                dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
                    event: 'formulario-enviado',
                    formulario: formulario.id
                });
            })
                .finally(function () { return submit.disabled = false; });
        });
    });
}, actualizaVisibilidad = function (campos, formulario) { return function () {
    var datos = new FormData(formulario), nombre = formulario.getAttribute('data-nombre');
    Object.values(campos).forEach(function (campo) {
        var erroneos = Object.keys(campo.visibilidad).filter(function (key) {
            var clave = "".concat(nombre, "[").concat(key, "]");
            var valores = datos.getAll(clave);
            return valores.indexOf(campo.visibilidad[key]) === -1;
        });
        if (erroneos.length === 0) {
            campo.input.required = campo.obligatorio;
            campo.input.parentElement.style.display = '';
        }
        else {
            campo.input.required = false;
            campo.input.parentElement.style.display = 'none';
        }
    });
}; }, configuraVisibilidad = function (campos, formulario) {
    var actualizador = actualizaVisibilidad(campos, formulario);
    formulario.addEventListener('change', actualizador);
    actualizador();
}, ajustaObligatorios = function (campos, formulario) {
    var nombreBase = formulario.getAttribute('data-nombre');
    formulario.addEventListener('change', function () {
        Object.keys(campos).forEach(function (key) {
            var _a = campos[key], input = _a.input, etiqueta = _a.etiqueta, condiciones = JSON.parse(input.getAttribute('data-required') || '{}');
            if (Object.keys(condiciones).length > 0) {
                var obligatorio = Object.keys(condiciones).reduce(function (valido, claveDelOtro) {
                    var otro = document.getElementById("".concat(nombreBase, "-").concat(claveDelOtro));
                    return valido && (!otro || otro.value === condiciones[claveDelOtro]);
                }, true);
                input.required = obligatorio;
                if (obligatorio && etiqueta.textContent.indexOf('*') === -1) {
                    etiqueta.textContent += ' *';
                }
                else if (!obligatorio && etiqueta.textContent.indexOf('*') !== -1) {
                    etiqueta.textContent = etiqueta.textContent.replace(' *', '');
                }
            }
        });
    }, true);
}, configuraArchivos = function (campos) {
    Object.keys(campos)
        .filter(function (clave) { return campos[clave].input.type === 'file'; })
        .map(function (x) { return campos[x]; })
        .forEach(function (archivo) {
        var input = archivo.input, etiqueta = archivo.etiqueta, campo = input.closest('.campo');
        if (campo) {
            var texto_1 = document.createElement('div');
            texto_1.innerHTML = '&nbsp;';
            campo.appendChild(texto_1);
            campo.addEventListener('drop', function (ev) {
                var _a;
                ev.preventDefault();
                if ((_a = ev.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) {
                    input.files = ev.dataTransfer.files;
                    campo.classList.add('con-archivo');
                    texto_1.textContent = input.files[0].name;
                    etiqueta.classList.remove('is-inactiva');
                }
            });
            campo.addEventListener('dragover', function (e) {
                campo.classList.add('archivo-encima');
                e.preventDefault();
            });
            campo.addEventListener('dragleave', function (e) {
                campo.classList.remove('archivo-encima');
            });
            input.addEventListener('change', function (e) {
                var nombre = input.value.split('\\').pop();
                if (nombre) {
                    texto_1.textContent = nombre;
                }
            });
        }
    });
};
var inicializaFormulario = function (formulario, opciones) {
    var _a;
    if (!formulario || formulario.classList.contains('inicializado')) {
        return;
    }
    formulario.classList.add('inicializado');
    var todosLosCampos = buscaCampos(formulario);
    if (opciones.ocultarEtiquetas) {
        configuraEtiquetas(formulario);
    }
    configuraSubmit(formulario, opciones);
    configuraArchivos(todosLosCampos);
    configuraVisibilidad(todosLosCampos, formulario);
    ajustaObligatorios(todosLosCampos, formulario);
    reinicia(todosLosCampos);
    (_a = opciones.onInicializado) === null || _a === void 0 ? void 0 : _a.call(opciones, formulario);
};
export default function formulario(selector, opciones) {
    opciones = __assign({ offset: function () { return 0; }, ocultarEtiquetas: true }, opciones);
    [].forEach.call(document.querySelectorAll(selector), function (formulario) {
        inicializaFormulario(formulario.closest('form'), opciones);
    });
}
